export const DEFAULT_ELEMENT = {
  "display-lg": "h1",
  "display-md": "h1",
  "display-sm": "h2",
  "headline-lg": "h2",
  "headline-md": "h2",
  "headline-sm": "h3",
  "title-lg": "h3",
  "title-md": "h4",
  "body-lg": "p",
  "body-md": "p",
  "label-lg": "span",
  "label-md": "span",
  "label-sm": "span",
};
